module.exports = __webpack_public_path__ + "static/media/998129.d84fac7a.png";